import { useModal } from './utils/Modal.js';
import { useRechercheExperte } from './RechercheExperteProvider.js';
import TypeDossiersForm from './TypeDossiers.js';
import AddBlocModal from './AddBlocModal.js';
import BlocThematiqueList from './BlocThematiqueList.js';
import AideModalButton from './AideModalButton.js';

const Form = () => {
  const {
    rechercheExperte,
    rechercheExperteForUrl,
    toggleTypeDossier,
    addBloc,
    resetRechercheExperte,
  } = useRechercheExperte();
  const { open: openAddBlocModal, setOpen: setOpenAddBlocModal } =
    useModal(false);

  const onThematiqueSelected = (thematiqueType) => {
    addBloc(thematiqueType);
    setOpenAddBlocModal(false);
  };

  return (
    <form className="expert-form" onSubmit={(event) => event.preventDefault()}>
      <h1 className="expert-form-title">Recherche avancée</h1>
      <div className="expert-form-header-actions">
        <button
          type="reset"
          className="expert-form-reset-btn"
          onClick={resetRechercheExperte}
        >
          Réinitialiser
        </button>
        <AideModalButton />
      </div>
      <TypeDossiersForm
        typeDossiers={rechercheExperte.typeDossiers}
        onChange={toggleTypeDossier}
      />
      <div className="expert-form-blocs">
        <BlocThematiqueList blocs={rechercheExperte.blocs} />
        <button
          type="button"
          className="expert-form-add-bloc-btn"
          onClick={() => setOpenAddBlocModal(true)}
        >
          Ajouter un bloc de recherche
        </button>
        <AddBlocModal
          open={openAddBlocModal}
          onSelect={onThematiqueSelected}
          onClose={() => setOpenAddBlocModal(false)}
        />
      </div>
      <div className="expert-form-footer-actions">
        <a
          href={`${
            window.routes.rechercheExperteResults ?? ''
          }?q=${rechercheExperteForUrl()}`}
          disabled={
            !rechercheExperte.typeDossiers ||
            !rechercheExperte.typeDossiers.length
          }
          className="expert-form-launch-search-btn"
        >
          Lancer la recherche
        </a>
      </div>
    </form>
  );
};

export default Form;
